<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" showExport="true" />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'FreeTradeAgreementTypes',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Типы соглашений',
        canEdit: true,
        apiRoute: 'nsifreetradeagreementtype',
        cardName: 'FreeTradeAgreementTypeCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
